import { Redirect, useParams } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUser } from 'shared/hooks';
import { useUserMapping } from 'shared/queries';
import { determineIsAdmin } from 'shared/utility';
import { UserMappingEditPage } from './user-mapping-edit-page';

export function UserMappingEditPageResolver() {
  const { userId } = useParams<{ userId: string }>();
  const user = useUser();
  const { userMapping } = useUserMapping(userId);

  if (!user || !userMapping) {
    return null;
  }

  const isAdmin = determineIsAdmin(user);
  if (!isAdmin) {
    return <Redirect to={ROUTES.products} />;
  }
  return <UserMappingEditPage mapping={userMapping} user={user} />;
}
